import { render, staticRenderFns } from "./UsersFilter.vue?vue&type=template&id=22150884&lang=pug&"
import script from "./UsersFilter.vue?vue&type=script&lang=js&"
export * from "./UsersFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports